
export const data3 = [
    {
        head: "Hot",
        day: "0 day ago",
        pos: "Java Back-end Developer",
        com: "Sunil Kumar",
        img1: "u",
        cty: "Bangalore +2",
        img2: "t",
        ex: " 2 to 7 years",
        ft1: "Be an Early Applicant",
        ft2: "Regular",
        vac: "8",
        id: 1
    },
    {
        head: "Hot",
        day: "0 day ago",
        pos: "Web development using mysql,bootstrap",
        com: "BIGWELT INFOTECH PRIVATE LIMITED",
        img1: "u",
        cty: "Visakapatnam",
        img2: "t",
        ex: " 0 to 1 years",
        ft1: "Be an Early Applicant",
        ft2: "Regular",
        vac: "10",
        id: 2

    },
    {
        head: "Hot",
        day: "0 day ago",
        pos: "Walk-In Drive For Team Leader",
        com: "GJ Solutions India Private Limited",
        img1: "u",
        cty: "Hyderabad",
        img2: "t",
        ex: " 1 to 2 years",
        ft1: "Be an Early Applicant",
        ft2: "Regular",
        vac: "10",
        id: 3
    },
    {
        head: "Hot",
        day: "0 day ago",
        pos: "Walk-In Drive For Customer Care Executives",
        com: "GJ Solutions India Private Limited",
        img1: "u",
        cty: "Hyderabad",
        img2: "t",
        ex: " 0 to 2 years",
        ft1: "Be an Early Applicant",
        ft2: "Regular",
        vac: "9",
        id: 4
    },
    {
        head: "Hot",
        day: "0 day ago",
        pos: "WALK-IN Interview For Relationship Manager",
        com: "OPTIMUM FUTURE Hiring For Clients",
        img1: "u",
        cty: "Chennai",
        img2: "t",
        ex: " 1 to 6 years",
        ft1: "Be an Early Applicant",
        ft2: "Regular",
        vac: "02",
        id: 5
    }
]